export interface HomeAddress {
  addressLine1?: string;
  addressLine2?: string;
  addressLine3?: string;
  city?: string;
  stateId?: number;
  stateName?: string;
  countryId?: number;
  countryName?: string;
  postalCode?: string;
  directions?: unknown;
  phoneNumber?: unknown;
  isEmpty?: boolean;
  isAddressComplete?: boolean;
}

export interface User {
  id: number;
  firstName: string;
  lastName: string;
  userName: string;
  email?: string;
  organizationId: number;
  portalCode: string;
  profileId: number;
  portalId: number;
  languageId: number;
  managerId?: unknown;
  managerName?: string | null;
  organizationName: string;
  pathToOrg: string;
  location: string;
  loginStatus: string;
  jobTitle: string;
  jobType: string;
  hireDate: Date;
  homePhone: string;
  workPhone?: string | null;
  website?: unknown;
  homeAddress?: HomeAddress;
  passwordResetPin?: unknown;
  notes?: unknown;
  fullName: string;
  isManager: boolean;
  token?: unknown;
  topLevelOrganizationId: number;
  middleName: string;
  userPassword?: unknown;
  endDate?: unknown;
  timeZone: string;
  custom0: string;
  custom1: string;
  custom2: string;
  custom3: string;
  custom4: string;
  custom5: string;
  custom6: string;
  custom7: string;
  custom8: string;
  custom9: string;
  personType: string;
  personStatus: string;
  roles: number[];
  alternateManagers?: unknown;
  jobId: number;
  lockedOut: boolean;
  lockedOutDate?: unknown;
  isSSO: boolean;
  ssoUsername?: unknown;
  totalCount: number;
  taRoleOrgIds: number[];
  isNMLSSafeHarbor: boolean;
  isNMLSReporting: boolean;
  isNMLSProvisioned: boolean;
  nmlsID?: string;
  nmlsEmail?: string;
  displayDueDateTime: boolean;
  addToTranscript: boolean;
  ldConnectAccess: boolean;
}

export enum RoleNames {
  Student = 'student',
  TA = 'ta',
  Author = 'author',
  Instructor = 'instructor',
  DecisionMaker = 'decisionMaker',
  Manager = 'manager',
}

export interface Role {
  id: number;
  type: RoleNames;
  name: keyof typeof RoleNames;
  subRole?: '';
}

export interface TaDomain {
  id: number;
  name: string;
  typeId: number;
  type: number;
  parentId: number;
  typeName: string;
  announcements?: unknown;
  description?: unknown;
  enabled: boolean;
  updateDateTime: Date;
  updateUserId: number;
  sourceCode: string;
  abbreviation: string;
  portalId: number;
  portalCode: string;
  isTopLevelOrg: boolean;
  hasActiveUsersAssigned: boolean;
  pathToOrg: string;
  parentOrgName?: unknown;
}

export interface ActiveDomain {
  id: number;
  name: string;
  typeId: number;
  type: number;
  parentId: number;
  typeName: string;
  announcements?: unknown;
  description?: unknown;
  enabled: boolean;
  updateDateTime: Date;
  updateUserId: number;
  sourceCode: string;
  abbreviation: string;
  portalId: number;
  portalCode: string;
  isTopLevelOrg: boolean;
  hasActiveUsersAssigned: boolean;
  pathToOrg: string;
  parentOrgName?: unknown;
}

export interface Impersonate {
  impersonatorDealerCode: string;
  impersonatorDealerId: number;
  impersonatorID: number;
  impersonatorRoles: string;
  impersonatorUserName: string;
}

export interface Auth {
  user: User;
  roles: Role[];
  currentRole: Role;
  legacy_userRole?: Role;
  sso: boolean;
  userApplicationType: string;
  loginStatus: string;
  errors?: unknown;
  errorText: string;
  languageId: number;
  organizationId: number;
  topLevelOrganizationId: number;
  profileId: number;
  portalId: number;
  portalCode: string;
  userAuthHash: string;
  utcTicks: number;
  isTopLevel: boolean;
  taDomains: TaDomain[];
  activeDomain: ActiveDomain;
  searchToken: string;
  customLogoUrl?: unknown;
  pausePortal: boolean;
  impersonate: Impersonate;
}
